// import React, { useEffect, useState } from "react";

// const CountdownTimer = ({ expiry }) => {

//   const calculateTimeLeft = (expiryDate) => {
//     const now = new Date();  
//     const difference = expiryDate.getTime() - now.getTime();

//     if (difference <= 0) return null;

//     return {
//       days: Math.floor(difference / (1000 * 60 * 60 * 24)),
//       hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
//       minutes: Math.floor((difference / 1000 / 60) % 60),
//       seconds: Math.floor((difference / 1000) % 60),
//     };
//   };

  
//   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(new Date(expiry)));

//   useEffect(() => {
//     const expiryDate = new Date(expiry);

  
//     if (timeLeft === null) return;

//     const timer = setInterval(() => {
//       setTimeLeft(calculateTimeLeft(expiryDate));  
//     }, 1000);


//     return () => clearInterval(timer);
//   }, [expiry, timeLeft]);  

 
//   if (!timeLeft) return <span style={{ color: "red" }}>Offer expired</span>;


//   return (
//     <span style={{ color: "#ff6f00", fontWeight: "normal" }}>
//       Offer expires in{" "}
//       {timeLeft.days > 0 ? `${timeLeft.days}d ` : ""}
//       {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
//     </span>
//   );
// };

// export default CountdownTimer;



import React, { useEffect, useState, useRef } from "react";

const CountdownTimer = ({ expiry }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const timerRef = useRef(null);

  const calculateTimeLeft = (expiryDate) => {
    const now = new Date();
    const difference = expiryDate.getTime() - now.getTime();

    if (difference <= 0) return null;

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  useEffect(() => {
    const expiryDate = new Date(expiry);

    // Set initial value
    setTimeLeft(calculateTimeLeft(expiryDate));

    timerRef.current = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(expiryDate);
      setTimeLeft(newTimeLeft);

      if (!newTimeLeft) {
        clearInterval(timerRef.current);
      }
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [expiry]);

  if (!timeLeft) {
    return <span style={{ color: "red" }}>Offer expired</span>;
  }

  return (
    <span style={{ color: "#ff6f00", fontWeight: "normal" }}>
      Offer expires in{" "}
      {timeLeft.days > 0 ? `${timeLeft.days}d ` : ""}
      {timeLeft.hours.toString().padStart(2, "0")}h{" "}
      {timeLeft.minutes.toString().padStart(2, "0")}m{" "}
      {timeLeft.seconds.toString().padStart(2, "0")}s
    </span>
  );
};

export default CountdownTimer;

